<template>
  <div class="cardUpcomingSkeleton">
    <div class="cardUpcomingSkeleton__date text-main skeletonLoading" />

    <div class="cardUpcomingSkeleton__content">
      <div class="flex-1">
        <div class="flex flex-col justify-between">
          <div class="relative flex items-center mb-1">
            <IconNoLogo class="cardUpcomingSkeleton__teamLogo skeletonLoading" :width="36" :height="36" />
            <div class="text-body-medium truncate text-main skeletonLoading h-4 w-24 mx-12" />
          </div>
          <div class="relative flex items-center">
            <IconNoLogo class="cardUpcomingSkeleton__teamLogo skeletonLoading" :width="36" :height="36" />
            <div class="text-body-medium truncate text-main skeletonLoading h-4 w-24 mx-12" />
          </div>
        </div>
        <div class="mt-4 flex justify-between">
          <div class="text-caption-medium text-secondary truncate skeletonLoading w-48 mr-2" />
          <div class="cardUpcomingSkeleton__sportTypeIcon skeletonLoading" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.cardUpcomingSkeleton {
  @apply flex flex-row max-w-full
  overflow-hidden cursor-wait
  transition duration-100
  hover:shadow-2xl;

  background-color: var(--base-card-bgColor);
  border-radius: var(--base-border-radius);

  .cardUpcomingSkeleton__date {
    @apply w-16 flex flex-col flex-shrink-0 justify-center items-center text-center;

    background-color: var(--base-card-bgSecondaryColor);
  }

  .cardUpcomingSkeleton__content {
    @apply relative p-3 pt-8
    max-w-full flex-grow-0
    flex flex-col justify-between;

    width: calc(100% - 64px);
  }

  .cardUpcomingSkeleton__teamLogo {
    @apply absolute z-10 h-9 w-9 flex-shrink-0 object-contain overflow-hidden rounded-full
    transform transition duration-500 hover:z-20 hover:scale-110;

    background-color: var(--base-card-bgSecondaryColor);
    border: 1px solid var(--base-card-bgColor);
  }

  .cardUpcomingSkeleton__sportTypeIcon {
    @apply w-4 h-4 rounded-full;
  }
}
</style>
